export const SWIPE_HORIZONTAL = {
  delta: 40,
};

export const SWIPE_VERTICAL = {
  delta: 50,
};
